<template>
  <div class="point_error">
    <section class="text_center">
      <h2 class="header_underline">SecurityMoney(セキュリティーマネー)決済エラー</h2>
      <p class="point_error_notice">SecurityMoney(セキュリティーマネー)決済でエラーが発生しました。</p>
      <p>
        <router-link :to="{ name: 'PointSecuritymoneyForm' }" class="arrow link_main--text">ポイント購入ページに戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PointSecuritymoneyError'
}
</script>
